import * as React from "react";
import { InfoWindowF } from "@react-google-maps/api";
import type { Zone } from "../../../types";
import { getMunicipalitiesForLine } from "../../../api/zones";
import { Icon, Badge, Heading } from "@ogt/ui";

type ZoneInfoWindowProps = {
  zone: Zone;
  position: google.maps.LatLngLiteral;
  onClose?: () => void;
};

export default function ZoneInfoWindow({
  zone,
  position,
  onClose,
}: ZoneInfoWindowProps) {
  const label = zone.name || "Närtrafikområde";

  const [municipalities, setMunicipalities] = React.useState<string[] | null>(
    null
  );
  const [loadingMunis, setLoadingMunis] = React.useState(false);

  React.useEffect(() => {
    const [linjeStr] = String(zone.id ?? "").split("_");
    const lineNrReal = Number(linjeStr);
    if (Number.isNaN(lineNrReal)) {
      setMunicipalities([]);
      return;
    }

    let cancelled = false;
    setLoadingMunis(true);
    getMunicipalitiesForLine(lineNrReal)
      .then((m) => {
        if (!cancelled) setMunicipalities(m ?? []);
      })
      .catch(() => {
        if (!cancelled) setMunicipalities([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingMunis(false);
      });

    return () => {
      cancelled = true;
    };
  }, [zone.id]);

  return (
    <InfoWindowF
      position={position}
      onCloseClick={onClose}
      options={{
        disableAutoPan: false,
        pixelOffset: new google.maps.Size(0, -12),
      }}
    >
      <div className=" pt-0 pl-4 pr-6 pb-6 min-w-[180px] text-sm leading-snug bg-[var(--semantic-color-bg-primary)]">
        {municipalities && municipalities.length > 0 && (
          <div className="flex gap-2 mb-4 items-center">
            <Badge
              icons={[<Icon key="n" name="n" />]}
              shape="default"
              state="default"
              variant="blue"
            ></Badge>
            <Heading
              as="h3"
              className="text-[var(--semantic-color-text-secondary)] mb-0"
            >
              {municipalities.join(", ")}
            </Heading>
          </div>
        )}

        <Heading as="h4" className=" text-[var(--semantic-color-text-primary)]">
          {label}
        </Heading>

        {loadingMunis && <div className=" mt-1">Hämtar kommun…</div>}
      </div>
    </InfoWindowF>
  );
}
